import API_CONFIG from '../../apiConfig';
import { GenerationType } from '../../hooks/useCreditEstimation';
import { WearCategory } from './wearCatalogueUtils';

export type CatalogueInputLayout = 'ecommerce' | 'active-wear';

export interface EcommerceExamplePreset {
  id: number;
  name: string;
  fullTop: string;
  closeUpTop: string;
  closeUpSleeveless: string;
}

export interface ActiveWearExamplePreset {
  id: number;
  name: string;
  top: string;
  bottom: string;
  back: string;
  full: string;
}

export interface CatalogueWorkflowConfig {
  featureName: string;
  presetsUrl: string;
  generateUrl: string;
  creditCostUrl: string;
  uploadUrl: string;
  creditType: GenerationType;
  downloadPrefix: string;
  inputLayout: CatalogueInputLayout;
  category?: WearCategory;
  examplePresets?: EcommerceExamplePreset[] | ActiveWearExamplePreset[];
}

const ACTIVE_WEAR_EXAMPLE_PRESETS: ActiveWearExamplePreset[] = [
  {
    id: 1,
    name: 'Sage Green Active Set',
    top: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-active-wear-photoshoot%2Fai-active-wear-input-top-1.webp?alt=media&token=fa56fb64-f9c6-49cf-b18a-187d715836cd',
    bottom: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-active-wear-photoshoot%2Fai-active-wear-input-buttom-1.webp?alt=media&token=8ac77b50-2c25-47b2-9ed0-4bd647d1bd56',
    back: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-active-wear-photoshoot%2Fai-active-wear-input-back-1.webp?alt=media&token=43f46486-117a-44f1-b617-2e7f94ba9bc1',
    full: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-active-wear-photoshoot%2Fai-active-wear-input-1.webp?alt=media&token=4855ad52-98e8-4d31-86ab-0adc2ce470c3',
  },
];

export const ECOMMERCE_CATALOGUE_CONFIG: CatalogueWorkflowConfig = {
  featureName: 'Ecommerce Photoshoot',
  presetsUrl: API_CONFIG.FASHION_CATALOGUE_PRESETS_URL,
  generateUrl: API_CONFIG.FASHION_CATALOGUE_GENERATE_URL,
  creditCostUrl: API_CONFIG.FASHION_CATALOGUE_CREDIT_COST_URL,
  uploadUrl: API_CONFIG.AI_WORKFLOW_UPLOAD_URL,
  creditType: 'ecommerce-catalogue',
  downloadPrefix: 'lookbook-perspective',
  inputLayout: 'ecommerce',
  examplePresets: [
    {
      id: 1,
      name: 'Sample Kurta',
      fullTop: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-catelogue-generator%2Fexample-1%2Fkurta.jpg.jpeg?alt=media&token=971b6fd9-7b20-474e-9f58-e4a4281414ec',
      closeUpTop: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-catelogue-generator%2Fexample-1%2Fclose%20shot.jpg.jpeg?alt=media&token=cb4b496c-2bca-466e-818c-5473e731ec21',
      closeUpSleeveless: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ffashion-catelogue-generator%2Fexample-1%2Fsleeves.jpg.jpeg?alt=media&token=639ee8cb-45d7-4164-a60d-4eebbfeffddb',
    },
  ],
};

export const GYM_WEAR_CATALOGUE_CONFIG: CatalogueWorkflowConfig = {
  featureName: 'Gym Wear Photoshoot',
  presetsUrl: API_CONFIG.ACTIVE_WEAR_CATALOGUE_PRESETS_URL,
  generateUrl: API_CONFIG.WEAR_CATALOGUE_GENERATE_URL,
  creditCostUrl: API_CONFIG.WEAR_CATALOGUE_CREDIT_COST_URL,
  uploadUrl: API_CONFIG.WEAR_CATALOGUE_UPLOAD_URL,
  creditType: 'wear-catalogue',
  downloadPrefix: 'gym-wear-lookbook',
  inputLayout: 'active-wear',
  category: 'active-wear',
  examplePresets: ACTIVE_WEAR_EXAMPLE_PRESETS,
};

export const YOGA_WEAR_CATALOGUE_CONFIG: CatalogueWorkflowConfig = {
  featureName: 'Yoga Wear Photoshoot',
  presetsUrl: API_CONFIG.YOGA_WEAR_CATALOGUE_PRESETS_URL,
  generateUrl: API_CONFIG.WEAR_CATALOGUE_GENERATE_URL,
  creditCostUrl: API_CONFIG.WEAR_CATALOGUE_CREDIT_COST_URL,
  uploadUrl: API_CONFIG.WEAR_CATALOGUE_UPLOAD_URL,
  creditType: 'wear-catalogue',
  downloadPrefix: 'yoga-wear-lookbook',
  inputLayout: 'active-wear',
  category: 'yoga-wear',
  examplePresets: ACTIVE_WEAR_EXAMPLE_PRESETS,
};
